// extracted by mini-css-extract-plugin
export default {"pulse":"pulse_pulse__27JD-"};